module.exports = __webpack_public_path__ + "static/media/gsp.c9437fa2.png";